import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

export const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { processGoogleSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      // Get session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/admin/login', { replace: true });
        return;
      }

      const sessionId = sessionIdMatch[1];

      try {
        const user = await processGoogleSession(sessionId);
        // Navigate to admin dashboard with user data
        navigate('/admin', { replace: true, state: { user } });
      } catch (error) {
        console.error('Auth callback error:', error);
        navigate('/admin/login', { replace: true });
      }
    };

    processAuth();
  }, [location.hash, navigate, processGoogleSession]);

  return (
    <div className="min-h-screen bg-[#F9F9F7] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <Loader2 className="w-12 h-12 animate-spin text-[#1A4D2E] mx-auto" />
        <p className="mt-4 text-[#666666]">Processant autenticació...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
